import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fad3b90&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad3b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fad3b90')) {
      api.createRecord('2fad3b90', component.options)
    } else {
      api.reload('2fad3b90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fad3b90&scoped=true", function () {
      api.rerender('2fad3b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spiritualPivot/index.vue"
export default component.exports